export const StorageKey = {
	SK_NAV_DATA: 'SK_NAV_DATA',
	SK_FOOTER_DATA: 'SK_FOOTER_DATA',
	SK_STORED_BOOKMARK: 'SK_STORED_BOOKMARK',
	SK_REMOTE_CONFIG: 'SK_REMOTE_CONFIG',
	SK_SESSION_REFRESH: 'SK_SESSION_REFRESH',
}
